import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listing: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'listing' }),
}

export { paths }
